import { cn } from '@avanta/shared/utils/cn';
import {
  dropdownCommandItem,
  dropdownContentBase,
  dropdownTriggerAppearance,
} from '../../../styles/dropdown';

export const countrySelectTrigger = (variant?: 'filled' | 'invalid' | null): string =>
  cn(
    dropdownTriggerAppearance,
    'gap-1 rounded-s-[8px] rounded-e-none border-r-0 px-3',
    variant === 'invalid' && [
      'bg-red-100 border-red-400',
      'data-[has-value=true]:bg-red-100 data-[has-value=true]:border-red-400',
    ],
    'disabled:pointer-events-none disabled:bg-gray-100 disabled:border-gray-200 disabled:text-gray-300'
  );

export const countrySelectContent = cn(
  dropdownContentBase,
  'origin-[--radix-popover-content-transform-origin] p-0',
  'w-72 min-w-(--radix-popover-trigger-width)'
);

export const countrySelectItem = dropdownCommandItem;

export const countrySelectScrollArea = 'h-72';
